import type { ListItemProps } from './types'
import { ListItem } from './ListItem'

export type SingleListItemProps = Omit<ListItemProps, 'ListComponent'>

/**
 * When you only want to place one item and are not using our List arround it
 * since the default is to paint an `li` this abstraction solves this by default for you :)
 */
export const SingleListItem = ({ children, ...rest }: SingleListItemProps) => (
  <ListItem {...rest} ListComponent="div">
    {children}
  </ListItem>
)
